import { finish, error } from '../../../modules/bonuses/actions/query-bonuses';
import api from '../../../api';

export function request(dispatch) {
    api.get('/bonus-rules', { fields: 'type,name'},{
        cache: 1000,
        headers: {
            'Cache-Control': 'public,max-age=3600'
        }
    }).then(
        (bonuses) => dispatch(finish(bonuses)),
        ({ errors }) => dispatch(error(errors))
    );
}
